/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Export_CancelledInputs */



/**
* | output |
* | --- |
* | "Export cancelled by user." |
*
* @param {Ateliere_Connect_Export_CancelledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_export_cancelled = /** @type {((inputs?: Ateliere_Connect_Export_CancelledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Export_CancelledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation annulée par l’utilisateur.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export vom Benutzer abgebrochen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione annullata dall'utente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт отменен пользователем.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación cancelada por el usuario.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户取消了导出操作。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートはユーザーによってキャンセルされました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता द्वारा निर्यात रद्द कर दिया गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação cancelada pelo usuário.")
	return /** @type {LocalizedString} */ ("Export cancelled by user.")
});